import { useStoreName } from 'domains/Auth/hooks';
import { useGetDomainSuggestionsQuery } from '../domainsApi';

export function useDomainSuggestionByName() {
  const storeName = useStoreName();

  const {
    data: { recommendation, suggestions } = {},
    isLoading,
    error,
  } = useGetDomainSuggestionsQuery(
    { query: `${storeName}.com` },
    { skip: !storeName },
  );

  return {
    recommendation,
    suggestions,
    isLoading,
    error,
    storeName,
  };
}
